import IMG_1 from 'assets/images/scooter/s2/s2_1.png'
import IMG_2 from 'assets/images/scooter/s2/s2_2.png'
import IMG_3 from 'assets/images/scooter/s2/s2_3.png'
import IMG_4 from 'assets/images/scooter/s2/s2_4.png'
import IMG_5 from 'assets/images/scooter/s2/s2_5.png'
import IMG_6 from 'assets/images/scooter/s2/s2_6.png'
import IMG_7 from 'assets/images/scooter/s2/s2_6_1.png'
import IMG_8 from 'assets/images/scooter/s2/s2_6_2.png'
import IMG_9 from 'assets/images/scooter/s2/s2_6_3.png'
import IMG_10 from 'assets/images/scooter/s2/s2_6_4.png'
import IMG_11 from 'assets/images/scooter/m1.png'
import IMG_12 from 'assets/images/scooter/s2/line.png'
import './ScooterS2.scss'

/**
 * @file 고고로 S2 화면
 */
function ScooterS2() {
    return (
        <>
            <div className="s2-one" style={{ backgroundImage: `url(${IMG_1})` }}>
                <div className="text-box">
                    <div className="sub">한계를 뛰어넘는 특별함</div>
                    <div className="t1">고고로 S2</div>
                </div>
            </div>
            <div className="s2-two" style={{ backgroundImage: `url(${IMG_2})` }} />

            <div className="s2-three" style={{ backgroundImage: `url(${IMG_3})` }}>
                <div className="text-box">
                    <img src={IMG_12} alt="효과" />
                    <div className="t1">새로운 차원을 달리다</div>
                    <div className="sub">
                        최고의 기술과 성능을 탑재한 S2는
                        <br />
                        정말 매력적인 주행을 선사합니다.
                    </div>
                    <div className="spec-box">
                        <div>
                            <div className="top">
                                <div className="point">3.8</div>
                                <div className="unit">초</div>
                            </div>
                            <div className="bottom">0-50 KM/H</div>
                        </div>
                        <div>
                            <div className="top">
                                <div className="point">7.2</div>
                                <div className="unit">
                                    kW @<br />
                                    3,000 rpm
                                </div>
                            </div>
                            <div className="bottom">강력한 모터 출력</div>
                        </div>
                        <div>
                            <div className="top">
                                <div className="point">213</div>
                                <div className="unit">
                                    NM
                                    <br />
                                    토크
                                </div>
                            </div>
                            <div className="bottom">강력한 토크</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="s2-four" style={{ backgroundImage: `url(${IMG_4})` }} />
            <div className="s2-five">
                <img src={IMG_5} alt="s2 description" />
            </div>
            <div className="s2-six" style={{ backgroundColor: '#000000', backgroundImage: `url(${IMG_6})` }}>
                <div className="text-box">
                    <div className="t1">기능까지 생각한 디자인</div>
                    <div className="sub">
                        부드럽고 유연한 디자인으로 바람 저항을 최소화합니다.
                        <br />
                        매력적인 차량과 함께 새로운 주행을 즐겨보세요.
                    </div>
                </div>
                <div className="system-column">
                    <div className="system-row">
                        <div className="black" style={{ backgroundImage: `url(${IMG_7})` }} />
                        <div>
                            <div className="text-box">
                                <div className="t1">BOSCH ABS 브레이크 시스템</div>
                                <div className="sub">휠 잠금을 방지하기 위해 초당 200회의 주파수로 작동합니다.</div>
                            </div>
                        </div>
                    </div>
                    <div className="system-row reverse">
                        <div>
                            <div className="text-box">
                                <div className="t1">유선형 테일 안장</div>
                                <div className="sub">가속과 코너링에서 탑승자의 몸을 더욱 안정적으로 지지합니다.</div>
                            </div>
                        </div>
                        <div className="black" style={{ backgroundImage: `url(${IMG_8})` }} />
                    </div>
                    <div className="system-row">
                        <div className="black" style={{ backgroundImage: `url(${IMG_9})` }} />
                        <div>
                            <div className="text-box">
                                <div className="t1">스마트 시스템</div>
                                <div className="sub">
                                    지속적으로 업데이트 되는
                                    <br />
                                    IQ 시스템을 통해 항상 최신 기능과
                                    <br />
                                    성능을 유지합니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="system-row reverse">
                        <div>
                            <div className="text-box">
                                <div className="t1">프론트 및 리어 서스펜션</div>
                                <div className="sub">
                                    서스펜션 시스템은 고속 주행 시<br />
                                    반동을 완벽하게 흡수합니다.
                                    <br />
                                    업그레이드된 프론트 및 리어 댐핑
                                    <br />
                                    조절로 매력적인 주행이 가능합니다.
                                </div>
                            </div>
                        </div>
                        <div className="black" style={{ backgroundImage: `url(${IMG_10})` }} />
                    </div>
                </div>
            </div>
            <div className="s2-seven">
                <div className="s2-motors-wrapper">
                    <img src={IMG_11} />
                    <div className="t1">고고로 S2 ABS</div>
                    <div className="sub">한계를 뛰어넘는 특별함</div>
                    <div className="colors">
                        <span style={{ background: 'linear-gradient(#1E58D5, #4E3688)' }} />
                        <span style={{ backgroundColor: '#323237' }} />
                        {/* 231005 색상 없어져서 주석처리 */}
                        {/* <span style={{ backgroundColor: '#F3F3F3' }} /> */}
                    </div>
                </div>
                <div className="details">
                    <div className="t1">디테일</div>
                    <div className="details-box">
                        <div>
                            <div className="box-row">
                                <div className="s1">길이 x 너비 x 높이 (백미러 제외)</div>
                                <div className="d1">1,895 x 675 x 1,095mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">휠베이스</div>
                                <div className="d1">1,325mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">안장 높이</div>
                                <div className="d1">780mm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">무게 (비어 있음/배터리 포함)</div>
                                <div className="d1">130/148kg</div>
                            </div>
                        </div>
                        <div>
                            <div className="box-row">
                                <div className="s1">최대 출력</div>
                                <div className="d1">7.2kw @3,000rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">최대 토크 (모터/휠)</div>
                                <div className="d1">26 / 213Nm @ 0-2,500rpm</div>
                            </div>
                            <div className="box-row">
                                <div className="s1">등판성</div>
                                <div className="d1">
                                    30%(17°): 40km/h
                                    <br />
                                    20%(11°): 50km/h
                                    <br />
                                    10%(6°): 70km/h
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="extra-describes">
                        * 이 표는 참고용이며 테스트 시나리오에 따라 결과가 달라질 수 있습니다.
                        <br />* 자세한 정보는 고객센터를 통해 확인해주시기 바랍니다.
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterS2
